"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('./HighchartsService');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var ChartSeriesComponent_1 = require("./ChartSeriesComponent");
var ChartXAxisComponent_1 = require("./ChartXAxisComponent");
var ChartYAxisComponent_1 = require("./ChartYAxisComponent");
var HighchartsService_1 = require("./HighchartsService");
var initChart_1 = require("./initChart");
var createBaseOpts_1 = require("./createBaseOpts");
var ChartComponent = (function () {
    function ChartComponent(element, highchartsService) {
        this.create = new core_1.EventEmitter();
        this.click = new core_1.EventEmitter();
        this.addSeries = new core_1.EventEmitter();
        this.afterPrint = new core_1.EventEmitter();
        this.beforePrint = new core_1.EventEmitter();
        this.drilldown = new core_1.EventEmitter();
        this.drillup = new core_1.EventEmitter();
        this.load = new core_1.EventEmitter();
        this.redraw = new core_1.EventEmitter();
        this.selection = new core_1.EventEmitter();
        this.type = 'Chart';
        this.element = element;
        this.highchartsService = highchartsService;
    }
    Object.defineProperty(ChartComponent.prototype, "options", {
        set: function (opts) {
            this.userOpts = opts;
            this.init();
        },
        enumerable: true,
        configurable: true
    });
    ;
    ChartComponent.prototype.init = function () {
        if (this.userOpts && this.baseOpts) {
            this.chart = initChart_1.initChart(this.highchartsService, this.userOpts, this.baseOpts, this.type);
            this.create.emit(this.chart);
        }
    };
    ChartComponent.prototype.ngAfterViewInit = function () {
        this.baseOpts = createBaseOpts_1.createBaseOpts(this, this.series, this.series ? this.series.point : null, this.xAxis, this.yAxis, this.element.nativeElement);
        this.init();
    };
ChartComponent.ɵfac = function ChartComponent_Factory(t) { return new (t || ChartComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.HighchartsService)); };
ChartComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ChartComponent, selectors: [["chart"]], contentQueries: function ChartComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ChartSeriesComponent_1.ChartSeriesComponent, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, ChartXAxisComponent_1.ChartXAxisComponent, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, ChartYAxisComponent_1.ChartYAxisComponent, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.series = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.xAxis = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.yAxis = _t.first);
    } }, inputs: { type: "type", options: "options" }, outputs: { create: "create", click: "click", addSeries: "addSeries", afterPrint: "afterPrint", beforePrint: "beforePrint", drilldown: "drilldown", drillup: "drillup", load: "load", redraw: "redraw", selection: "selection" }, features: [ɵngcc0.ɵɵProvidersFeature([HighchartsService_1.HighchartsService])], decls: 1, vars: 0, template: function ChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\u00A0");
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChartComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'chart',
                template: '&nbsp;',
                providers: [HighchartsService_1.HighchartsService]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.HighchartsService }]; }, { create: [{
            type: core_1.Output
        }], click: [{
            type: core_1.Output
        }], addSeries: [{
            type: core_1.Output
        }], afterPrint: [{
            type: core_1.Output
        }], beforePrint: [{
            type: core_1.Output
        }], drilldown: [{
            type: core_1.Output
        }], drillup: [{
            type: core_1.Output
        }], load: [{
            type: core_1.Output
        }], redraw: [{
            type: core_1.Output
        }], selection: [{
            type: core_1.Output
        }], type: [{
            type: core_1.Input
        }], options: [{
            type: core_1.Input
        }], series: [{
            type: core_1.ContentChild,
            args: [ChartSeriesComponent_1.ChartSeriesComponent]
        }], xAxis: [{
            type: core_1.ContentChild,
            args: [ChartXAxisComponent_1.ChartXAxisComponent]
        }], yAxis: [{
            type: core_1.ContentChild,
            args: [ChartYAxisComponent_1.ChartYAxisComponent]
        }] }); })();
    return ChartComponent;
}());
__decorate([
    core_1.ContentChild(ChartSeriesComponent_1.ChartSeriesComponent),
    __metadata("design:type", ChartSeriesComponent_1.ChartSeriesComponent)
], ChartComponent.prototype, "series", void 0);
__decorate([
    core_1.ContentChild(ChartXAxisComponent_1.ChartXAxisComponent),
    __metadata("design:type", ChartXAxisComponent_1.ChartXAxisComponent)
], ChartComponent.prototype, "xAxis", void 0);
__decorate([
    core_1.ContentChild(ChartYAxisComponent_1.ChartYAxisComponent),
    __metadata("design:type", ChartYAxisComponent_1.ChartYAxisComponent)
], ChartComponent.prototype, "yAxis", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "create", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "click", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "addSeries", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "afterPrint", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "beforePrint", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "drilldown", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "drillup", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "load", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "redraw", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ChartComponent.prototype, "selection", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ChartComponent.prototype, "type", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], ChartComponent.prototype, "options", null);
ChartComponent = __decorate([ __metadata("design:paramtypes", [core_1.ElementRef, HighchartsService_1.HighchartsService])
], ChartComponent);
exports.ChartComponent = ChartComponent;

